import PropTypes from 'prop-types';

const HTMLContainer = ({ value, className, children }) => {
  let html = value ? value : children;

  if (!html) {
    return null;
  }

  // All links in an html container will be opened in a new tab.
  if (typeof html === `string`) {
    html = html.replaceAll('<a href=', '<a target="_blank" rel="noopener" href=');
  }

  return <div dangerouslySetInnerHTML={ { __html: html } } className={ className }/>;
}

HTMLContainer.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
}

export default HTMLContainer;
